module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/products-v2/products-v2.component.css
// module id = ./src/app/products-v2/products-v2.component.css
// module chunks = main